import { Smile } from "@wix/wix-ui-icons-common";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common/index.js";
import { INSERT_EMOJI_BUTTON } from "./data-hooks.js";
import EmojiInsertModal from "./modals/InsertModal.js";
import { EMOJI_TYPE, emojiModals } from "./types.js";
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (_config, services) => {
  const {
    modals,
    context: { isMobile = false }
  } = services || {};
  return isMobile ? [] : [
    {
      id: EMOJI_TYPE,
      label: INSERT_PLUGIN_BUTTONS.EMOJI,
      dataHook: INSERT_EMOJI_BUTTON,
      icon: Smile,
      tooltip: "EmojiPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ referenceElement }) => {
        modals?.togglePluginPanel({
          id: emojiModals.insert,
          Component: EmojiInsertModal,
          componentProps: {},
          isMobile: false,
          positioning: {
            referenceElement,
            placement: "bottom"
          }
        });
        return true;
      },
      menuConfig: {
        tags: "Emoji_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
